var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVariant3 = function SvgVariant3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 172 172"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86,
    r: 71.418,
    stroke: "#F07D00",
    strokeDasharray: "0.1 4",
    strokeLinecap: "round",
    transform: "rotate(-60 86 86)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F07D00",
    d: "m30.63 138.924-5.047-.525-.128-5.072-7.012-7.585.475 18.819 18.722 1.946z",
    opacity: 0.3
  })));
};
export default SvgVariant3;